import { FETCH_GIFT_CARD } from 'actions/apiActionConstants'
import { createAppReducer, apiReducerSwitch } from 'lib/redux/reducerUtils'
import { API_CALL_REQUEST, API_CALL_FAILURE, API_CALL_SUCCESS } from 'actions/actionConstants'

export const initialGiftCardState: App.GiftCardState = {
  error: {},
  fetching: false,
  giftCard: undefined,
  giftCardOptions: [],
}

const apiCalls = apiReducerSwitch<App.GiftCardState>({
  [FETCH_GIFT_CARD]: {
    request: () => ({
      fetching: true,
      error: undefined,
    }),
    success: (state, action) => ({
      giftCard: action.data,
      fetching: false,
    }),
    failure: (state, action) => ({
      fetching: false,
      error: action.error,
    }),
  },
})

export default createAppReducer<App.GiftCardState>(initialGiftCardState, {
  [API_CALL_REQUEST]: (state, action) => apiCalls(state, action),
  [API_CALL_FAILURE]: (state, action) => apiCalls(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiCalls(state, action),
})
